module.exports = __webpack_public_path__ + "static/media/21ECLAC51.0a0b494a.jpg";